import {Injectable} from '@angular/core';

@Injectable()
export class FormsGlobals {
  // Control Valid Value Items
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  STATUS_NOT_STARTED = '00000041-1000-0000-0000-000000000001';
  STATUS_STARTED = '00000041-1000-0000-0000-000000000002';
  STATUS_COMPLETED = '00000041-1000-0000-0000-000000000003';
  STATUS_CANCELED = '00000041-1000-0000-0000-000000000004';
  STATUS_COMPLETEDANDSIGNED = '00000041-1000-0000-0000-000000000005';

  CONTROL_TEXT_BOX: string = '00000001-1000-0000-0000-000000000001';
  CONTROL_HEADING: string = '00000001-1000-0000-0000-000000000002';
  CONTROL_GROUP_HEADING_WITH_SUMMARY: string = '00000001-1000-0000-0000-000000000003';
  CONTROL_RADIO_LIST: string = '00000001-1000-0000-0000-000000000004';
  CONTROL_CHECK_BOX_LIST: string = '00000001-1000-0000-0000-000000000005';
  CONTROL_LABEL: string = '00000001-1000-0000-0000-000000000006';
  CONTROL_CHECK_BOX: string = '00000001-1000-0000-0000-000000000007';
  CONTROL_NUMERIC_SLIDER: string = '00000001-1000-0000-0000-000000000008';
  CONTROL_NUMERIC_INTEGER: string = '00000001-1000-0000-0000-000000000009';
  CONTROL_NUMERIC_DECIMAL: string = '00000001-1000-0000-0000-000000000010';
  CONTROL_DATE: string = '00000001-1000-0000-0000-000000000011';
  CONTROL_TIME: string = '00000001-1000-0000-0000-000000000012';
  CONTROL_DATE_TIME: string = '00000001-1000-0000-0000-000000000013';
  CONTROL_COMBO_LIST: string = '00000001-1000-0000-0000-000000000014';
  CONTROL_CURRENCY: string = '00000001-1000-0000-0000-000000000015';
  CONTROL_AUTOFILL_FORM: string = '00000001-1000-0000-0000-000000000016';
  CONTROL_BLOOD_PRESSURE: string = '00000001-1000-0000-0000-000000000017';
  CONTROL_LABEL_45: string = '00000001-1000-0000-0000-000000000018';
  CONTROL_TOOTH_PICKER: string = '00000001-1000-0000-0000-000000000019';
  CONTROL_ACTION_BUTTON: string = '00000001-1000-0000-0000-000000000020';
  CONTROL_ROW_HEADER: string = '00000001-1000-0000-0000-000000000021';
  CONTROL_SMALL_CHECK_BOX: string = '00000001-1000-0000-0000-000000000022';
  CONTROL_NUMERIC_DRAG_INPUT_SLIDER: string = '00000001-1000-0000-0000-000000000023';
  CONTROL_VITAL_SIGNS: string = '00000001-1000-0000-0000-000000000024';
  CONTROL_TEXT_AREA: string = '00000001-1000-0000-0000-000000000025';
  CONTROL_SPACER: string = '00000001-1000-0000-0000-000000000026';
  CONTROL_SIGNATURE: string = '00000001-1000-0000-0000-000000000027';
  CONTROL_PHONE: string = '00000001-1000-0000-0000-000000000028';
  CONTROL_BULLETPOINT: string = '00000001-1000-0000-0000-000000000029';
  CONTROL_HIDDENINPUT: string = '00000001-1000-0000-0000-000000000030';
  CONTROL_MARKUP: string = '00000001-1000-0000-0000-000000000031';
  CONTROL_MACRO_NOTES_DROPDOWN: string = '00000001-1000-0000-0000-000000000032';
  CONTROL_IMAGE_LIST: string = '00000001-1000-0000-0000-000000000033';

  FORM_STATUS_DRAFT: string = '00000015-1000-0000-0000-000000000001';
  FORM_STATUS_READY_FOR_REVIEW: string = '00000015-1000-0000-0000-000000000002';
  FORM_STATUS_IN_REVIEW: string = '00000015-1000-0000-0000-000000000003';
  FORM_STATUS_APPROVED: string = '00000015-1000-0000-0000-00000000000A';

  FORM_CATEGORY_GENERAL: string = '00000014-1000-0000-0000-000000000001';
  FORM_CATEGORY_ENDO: string = '00000014-1000-0000-0000-000000000002';
  FORM_CATEGORY_PERIO: string = '00000014-1000-0000-0000-000000000003';

  FORM_DATA_SOURCE_GENERIC: string = '00000030-1000-0000-0000-000000000001';
  FORM_DATA_SOURCE_CUSTOM: string = '00000030-1000-0000-0000-000000000002';

  ITEM_LAYOUT_SBS: string = '0000001F-1000-0000-0000-000000000001'.toLowerCase();
  PARAGRAPH_LAYOUT_HORIZONTAL: string = '00000020-1000-0000-0000-000000000001'.toLowerCase();
  PARAGRAPH_LAYOUT_VERTICAL: string = '00000020-1000-0000-0000-000000000002'.toLowerCase();
  ITEM_LAYOUT_TWO_LINE: string = '0000001F-1000-0000-0000-000000000002'.toLowerCase();

  public controlIdsForNotes = [
    this.CONTROL_CHECK_BOX,
    this.CONTROL_TEXT_BOX,
    this.CONTROL_COMBO_LIST,
    this.CONTROL_RADIO_LIST,
    this.CONTROL_CHECK_BOX_LIST
  ];
}
